import { getDateFormat, getCurrentLocale } from "../src/services/user/datetime.services";

export const setToken = (accessToken1, refreshToken1) => {
    localStorage.setItem('accessToken1', accessToken1);
    localStorage.setItem('refreshToken1', refreshToken1);
}

export const getToken = () => {
    let accessToken1 = localStorage.getItem('accessToken');
    let refreshToken1 = localStorage.getItem('refreshToken');
    return { accessToken1, refreshToken1 };
}

export const CURRENCY_ENUM = [
    { currencyId: 1, currencyName: 'Indian Rupee', shortName: 'INR' },
    { currencyId: 2, currencyName: 'US Dollar', shortName: 'USD' },
    { currencyId: 3, currencyName: 'Euro', shortName: 'EUR' },
    { currencyId: 4, currencyName: 'British Pound', shortName: 'GBP' },
    { currencyId: 5, currencyName: 'Australian Dollar', shortName: 'AUD' },
    { currencyId: 6, currencyName: 'Indonesia Rupiah', shortName: 'IDR' },
    { currencyId: 7, currencyName: 'Iraq Dinar', shortName: 'IQD' },
];

export const INTRA_STATE_TAX_GROUP_ENUM = [
    { intraStateTaxGroupId: 1, intraStateTaxGroupName: 'GST 0%' },
    { intraStateTaxGroupId: 2, intraStateTaxGroupName: 'GST 5%' },
    { intraStateTaxGroupId: 3, intraStateTaxGroupName: 'GST 12%' },
    { intraStateTaxGroupId: 4, intraStateTaxGroupName: 'GST 18%' },
    { intraStateTaxGroupId: 5, intraStateTaxGroupName: 'GST 28%' },
];

export const VALIDITY_ENUM = [
    { validityId: 1, validityName: '7 days' },
    { validityId: 2, validityName: '14 days' },
    { validityId: 3, validityName: '30 days' },
    { validityId: 4, validityName: '45 days' },
]

export const INTER_STATE_TAX_GROUP_ENUM = [
    { interStateTaxGroupId: 1, interStateTaxGroupName: 'GST 0%' },
    { interStateTaxGroupId: 2, interStateTaxGroupName: 'GST 5%' },
    { interStateTaxGroupId: 3, interStateTaxGroupName: 'GST 12%' },
    { interStateTaxGroupId: 4, interStateTaxGroupName: 'GST 18%' },
    { interStateTaxGroupId: 5, interStateTaxGroupName: 'GST 28%' },
];

export const TAX_TYPE_ENUM = [
    { group: 'intraStateTaxGroup', name: "Intra State" },
    { group: 'interStateTaxGroup', name: "Inter State" }
];

const COLORS_ENUM = [
    { colorId: 0, colorName: 'Blue', backgroundColor: '#002E94', textColor: '#FFFFFF' },
    { colorId: 1, colorName: 'Teal', backgroundColor: '#00ABB3', textColor: '#FFFFFF' },
    { colorId: 2, colorName: 'Green', backgroundColor: '#198754', textColor: '#FFFFFF' },
    { colorId: 3, colorName: 'Pink', backgroundColor: '#A91079', textColor: '#FFFFFF' },
    { colorId: 4, colorName: 'Red', backgroundColor: '#D2001A', textColor: '#FFFFFF' },
    { colorId: 5, colorName: 'Gold', backgroundColor: '#A47E3B', textColor: '#000000' },
    { colorId: 6, colorName: 'Purple', backgroundColor: '#800080', textColor: '#FFFFFF' },
    { colorId: 7, colorName: 'Orange', backgroundColor: '#FF731D', textColor: '#FFFFFF' },
    { colorId: 8, colorName: 'Yellow', backgroundColor: '#F8B400', textColor: '#000000' },
];

export const getButtonStylesName = (statusName) => {
    const color = COLORS_ENUM.find(color => color.colorName === statusName);
    return color ? { backgroundColor: color.backgroundColor, textColor: color.textColor } : { backgroundColor: '#f8f9fa', textColor: '#000000' }; // Default styles
};

export const getButtonStyles = (status) => {
    const color = COLORS_ENUM.find(color => color.colorId === status.colorId);
    return color ? { backgroundColor: color.backgroundColor, textColor: color.textColor } : { backgroundColor: '#f8f9fa', textColor: '#000000' }; // Default styles
};

export const ItemTypeEnum = {
    main: "main",
    sub: "sub",
};

export const ChildTypeEnum = {
    standard: "standard",
    optional: "optional",
};

export const SubChildEnum = {
    accessories: "accessories",
    software: "software",
};

export const getVersion = () => "v003";

// export function parseCultureDate(dateStr) {
//     if (!dateStr) return null;

//     if (dateStr instanceof Date) return dateStr;

//     const str = String(dateStr);

//     const parts = str.includes('/') ? str.split('/') : str.split('-');
//     if (parts.length !== 3) return null;

//     const day = parseInt(parts[0], 10);
//     const month = parseInt(parts[1], 10) - 1;
//     const year = parseInt(parts[2], 10);

//     const d = new Date(year, month, day);
//     return isNaN(d.getTime()) ? null : d;
// }
// export function parseCultureDate(dateStr) {
//     if (!dateStr) return null;
//     if (dateStr instanceof Date) return dateStr;

//     const str = String(dateStr);
//     const parts = str.includes('/') ? str.split('/') : str.split('-');
//     if (parts.length !== 3) return null;

//     const month = parseInt(parts[0], 10) - 1; // MM
//     const day = parseInt(parts[1], 10);       // DD
//     const year = parseInt(parts[2], 10);      // YYYY

//     const d = new Date(year, month, day);
//     return isNaN(d.getTime()) ? null : d;
// }
export function parseCultureDate(dateStr) {
    if (!dateStr) return null;
    if (dateStr instanceof Date) return dateStr;

    const str = String(dateStr).trim();

    // Handle ISO string like 2026-10-08T11:35:09.000Z
    if (str.includes("T")) {
        const d = new Date(str);
        return isNaN(d.getTime()) ? null : d;
    }

    // Handle dd/MM/yyyy (common culture format)
    if (str.includes("/")) {
        const [day, month, year] = str.split("/");
        const d = new Date(+year, +month - 1, +day);
        return isNaN(d.getTime()) ? null : d;
    }

    // Handle yyyy-MM-dd
    if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
        const [year, month, day] = str.split("-");
        const d = new Date(+year, +month - 1, +day);
        return isNaN(d.getTime()) ? null : d;
    }

    // Handle MM-DD-YYYY
    if (/^\d{2}-\d{2}-\d{4}$/.test(str)) {
        const [month, day, year] = str.split("-");
        const d = new Date(+year, +month - 1, +day);
        return isNaN(d.getTime()) ? null : d;
    }

    return null;
}


// DATE FORMAT
export { getDateFormat, getCurrentLocale };

// let DEFAULT_LOCALE = 'en-IN';

// const localeDateFormats = {
//     'en-IN': 'dd-MM-yyyy',
//     'en-US': 'MM/dd/yyyy',
//     'fr-FR': 'dd/MM/yyyy',
// };

// export function getDateFormat() {
//     return localeDateFormats[DEFAULT_LOCALE] || 'dd-MM-yyyy';
// }

// export function getCurrentLocale() {
//     return DEFAULT_LOCALE;
//}

// export async function fetchDefaultLocale() {
//     try {
//         const res = await fetch(EndPoint.LOCALE);
//         const data = await res.json();

//         if (data && data.locale) {
//             DEFAULT_LOCALE = data.locale;
//             console.log('Locale loaded from backend:', DEFAULT_LOCALE);
//         } else {
//             console.warn('Backend did not return locale, using fallback:', DEFAULT_LOCALE);
//         }
//     } catch (err) {
//         console.error('Failed to fetch locale, using default', err);
//     }
// }